import { Async as ReactSelect } from 'react-select';

import PropTypes from 'prop-types';

export default class Async extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    defaultOptions: PropTypes.bool,
    disabled: PropTypes.bool,
    isClearable: PropTypes.bool,
    loadOptions: PropTypes.func.isRequired,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    multi: false,
    styles: {},
  };

  render() {
    const {
      autoFocus,
      className,
      defaultOptions,
      disabled,
      isClearable,
      loadOptions,
      multi,
      name,
      onBlur,
      onChange,
      readOnly,
      styles,
      title,
      value,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        defaultOptions={defaultOptions}
        id={name}
        isClearable={isClearable}
        isDisabled={disabled}
        isMulti={multi}
        loadingMessage={() => window.Alfresco.messages.global['label.loading']}
        loadOptions={loadOptions}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        readOnly={readOnly}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        styles={styles}
        title={title}
        value={value}
      />
    );
  }
}
